import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion + "settings/organization_settings/referral_categories"
});

export const api = {
  getReferralCategories(params) {
    return instance.get("", params);
  },
  getActions(params) {
    return instance.get("get_actions_list", params);
  },
  getReferralCategory(id, params) {
    return instance.get(`/${id}`, params);
  },
  getUnassignedKeywords(params) {
    return instance.get("/unassigned_keywords", params);
  },
  exportReferralCategories(params) {
    return instance.get("/export", params);
  },
  importReferralCategories(params) {
    return instance.post("/import", params);
  },
  recalculateReferralCategories(params) {
    return instance.post("/recalculate_values", params);
  },
  assignReferralCategory(params) {
    return instance.put("/assign", params);
  },
  unassignReferralCategoryKeyword(params) {
    return instance.put("/unassign", params);
  },
  unassignAllReferralCategoryKeywords(params) {
    return instance.put("/unassign_all", params);
  }
};
